<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      d="M11.5449 48.0977C12.2451 48.0977 12.8125 48.665 12.8125 49.3652C12.8124 50.0654 12.2451 50.6328 11.5449 50.6328C10.8448 50.6327 10.2774 50.0653 10.2773 49.3652C10.2773 48.6651 10.8448 48.0977 11.5449 48.0977ZM34.3662 3.54102C46.8701 3.54102 57.0068 13.6777 57.0068 26.1816C57.0067 38.6854 46.87 48.8213 34.3662 48.8213C21.8625 48.8212 11.7267 38.6853 11.7266 26.1816C11.7266 13.6778 21.8624 3.54115 34.3662 3.54102ZM65.8818 8.6123C67.9824 8.61234 69.6855 10.3154 69.6855 12.416C69.6855 14.5166 67.9825 16.2197 65.8818 16.2197C63.7812 16.2197 62.0781 14.5167 62.0781 12.416C62.0782 10.3154 63.7812 8.6123 65.8818 8.6123ZM53.9277 1.36719C55.0281 1.36721 55.9199 2.26002 55.9199 3.36035C55.9197 4.4605 55.0279 5.35252 53.9277 5.35254C52.8275 5.35254 51.9358 4.46052 51.9355 3.36035C51.9355 2.26001 52.8274 1.36719 53.9277 1.36719Z"
      fill="url(#paint0_radial_410_32627)"
    />
    <path
      d="M24.2624 36.5859C23.4185 36.5859 22.7344 35.9006 22.7344 35.0551L22.7344 16.303C22.7344 15.4576 23.4185 14.7722 24.2624 14.7722L47.5646 14.7722C48.4085 14.7722 49.0926 15.4576 49.0926 16.303L49.0926 35.0551C49.0926 35.9006 48.4085 36.5859 47.5646 36.5859L24.2624 36.5859Z"
      fill="url(#paint1_radial_410_32627)"
    />
    <path
      d="M25.4629 32.9717L25.4629 18.3867C25.4629 17.9095 25.8725 17.499 26.4072 17.499L45.4238 17.499C45.9586 17.499 46.3682 17.9095 46.3682 18.3867L46.3682 32.9717C46.3681 33.4488 45.9585 33.8594 45.4238 33.8594L26.4072 33.8594C25.8726 33.8594 25.463 33.4488 25.4629 32.9717Z"
      stroke="url(#paint2_radial_410_32627)"
      stroke-width="0.605937"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.543 16.8147C44.9208 17.1453 44.9591 17.7195 44.6285 18.0973L40.1215 23.2481C39.5541 23.8966 38.5607 23.9418 37.9368 23.3476L37.0702 22.5222L34.6699 24.9427C34.1954 25.4211 33.462 25.5287 32.8702 25.2066L31.049 24.2155L28.765 26.08C28.3761 26.3974 27.8035 26.3395 27.4861 25.9507C27.1687 25.5618 27.2266 24.9893 27.6154 24.6718L30.0571 22.6786C30.5338 22.2894 31.1986 22.2273 31.7392 22.5215L33.5393 23.5012L35.9885 21.0314C36.5692 20.4458 37.5116 20.4324 38.1088 21.0011L38.9616 21.8133L43.2605 16.9002C43.591 16.5225 44.1652 16.4842 44.543 16.8147Z"
      fill="url(#paint3_radial_410_32627)"
    />
    <g opacity="0.5" filter="url(#filter0_f_410_32627)">
      <path
        d="M18.9271 26.129C18.4141 24.562 19.5817 22.9512 21.2305 22.9512L27.9863 22.9512C28.5003 22.9512 28.9902 23.1687 29.3349 23.55L30.8275 25.2013C31.1722 25.5826 31.6621 25.8002 32.1761 25.8002L44.8222 25.8002C45.8078 25.8002 46.6953 26.3971 47.067 27.3099L50.5338 35.8248C50.8583 36.6218 50.2719 37.4937 49.4114 37.4937H23.5261C23.0021 37.4937 22.5374 37.1568 22.3744 36.6588L18.9271 26.129Z"
        fill="url(#paint4_radial_410_32627)"
      />
    </g>
    <path
      d="M19.8313 27.036C19.3209 25.4696 20.4883 23.8613 22.1358 23.8613L27.0391 23.8613C27.5538 23.8613 28.0444 24.0795 28.3891 24.4618L29.6879 25.9021C30.0326 26.2844 30.5232 26.5026 31.0379 26.5026H43.5221C44.5092 26.5026 45.3977 27.1012 45.7684 28.0161L48.8727 35.6764C49.1955 36.4732 48.6092 37.3435 47.7495 37.3435H24.0696C23.545 37.3435 23.0799 37.0059 22.9174 36.507L19.8313 27.036Z"
      fill="url(#paint5_linear_410_32627)"
    />
    <defs>
      <filter
        id="filter0_f_410_32627"
        x="17.5928"
        y="21.7393"
        width="34.2441"
        height="16.9667"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.605937"
          result="effect1_foregroundBlur_410_32627"
        />
      </filter>
      <radialGradient
        id="paint0_radial_410_32627"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.5735 -11.6281) rotate(117.322) scale(76.1914 80.099)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32627"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(55.3035 9.47026) rotate(140.481) scale(42.6126 46.6633)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32627"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.8244 32.4933) rotate(-60.1252) scale(25.6607 30.0054)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32627"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.9445 22.9143) rotate(-180) scale(42.0156 22.8656)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32627"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.7664 28.1245) rotate(88.2361) scale(28.1217 63.507)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <linearGradient
        id="paint5_linear_410_32627"
        x1="36.369"
        y1="39.6157"
        x2="36.369"
        y2="23.8613"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
    </defs>
  </svg>
</template>
